module.exports = __webpack_public_path__ + "static/media/Storm.57ff08c0.jpg";